// `isSample` is a server-owned flag (the starter template created at signup) that is not on the
// generated TemplateVM until client-api is regenerated from the merged backend. Read it through
// a minimal local type; swap to `template?.isSample` once the generated field exists.
export const isSampleTemplate = (template?: unknown): boolean =>
  (template as { isSample?: boolean } | null | undefined)?.isSample === true;
